// src/App.jsx
import React from "react";
import { useAuth, hasAuthParams } from "react-oidc-context";
import { BrowserRouter } from "react-router-dom";
import Router from "./services/RouteService";



function App() {
    const auth = useAuth();
    const [hasTriedSignin, setHasTriedSignin] = React.useState(false);

    React.useEffect(() => {
        if (!hasAuthParams() &&
            !auth.isAuthenticated && !auth.activeNavigator && !auth.isLoading &&
            !hasTriedSignin
        ) {
            auth.signinRedirect();
            setHasTriedSignin(true);
        }
    }, [auth, hasTriedSignin]);


    if (auth.activeNavigator === "signinSilent")
        return <div>Signing you in...</div>;

    if (auth.activeNavigator === "signoutRedirect")
        return <div>Signing you out...</div>;

    if (auth.isLoading) {
        return <div>Loading...</div>;
    }

    if (auth.error) {
        return <div>Oops... {auth.error.kind} caused {auth.error.message}</div>;
    }

    if (auth.isAuthenticated) {
        return (
            <BrowserRouter>
                <Router>
                </Router>
            </BrowserRouter>
        );
    }
    else {
        return <button onClick={() => void auth.signinRedirect()}>Log in</button>;
    }
}

export default App;